import {
  CommonI18nextProvider,
  createFeedbackModuleEntry,
  createUnsupportedBrowserNoticeModuleEntry,
} from 'react-common'
import { DevextremeI18nextProvider } from '@lms/devextreme-common'
import { PdfViewerI18nextProvider } from '@lms/lms-pdf-viewer'
import i18n from '@/plugins/i18n'

type Props = {
  children: React.ReactNode
}

const providers = [CommonI18nextProvider, DevextremeI18nextProvider, PdfViewerI18nextProvider]
const entries = [createFeedbackModuleEntry, createUnsupportedBrowserNoticeModuleEntry]

export const CombinedI18nextProvider = ({ children }: Props) => {
  const entry = entries.reduce((children, entry) => {
    const Wrapper = entry(() => children, { i18Instance: i18n })
    return <Wrapper />
  }, children)

  return providers.reduce((children, Provider) => {
    return <Provider i18n={i18n}>{() => children}</Provider>
  }, entry)
}
